import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    disabled: _ctx.disable,
    class: _normalizeClass(["btn btn-md preset-filled-primary-500 transition-all disabled:bg-primary-950 disabled:text-opacity-50 disabled:brightness-75 disabled:cursor-not-allowed py-5", {'w-full': _ctx.stretch}])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}